import React, { useRef, useState, useEffect } from 'react';
import MainPage from './components/MainPage';
import MobilePage from './components/mobilecomps/MobilePage';
import PropTypes from 'prop-types';
import filtersMeta from './filtersMeta.js';
import dayjs from 'dayjs';
import { useAppConfig } from '@state';
import { utils } from '@ohif/core';
import oneWeekDay from './utils/getOneWeekDay.js';
import { Modal } from 'antd';

import './StudyListPage.less';
const { apiService } = utils;

const StudyListPage = ({ handleTabChange,flag }: withAppTypes) => {
  const [appConfig] = useAppConfig();
  const sessionQueryFilterValues = sessionStorage.getItem('filterValues')
    ? JSON.parse(sessionStorage.getItem('filterValues'))
    : {};
  const [filterValues, _setFilterValues] = useState({
    currentPage: '1',
    pageSize: 10,
    no_type: 'patient_id',
    sort: 'r.register_time desc',
    register_time_begin: oneWeekDay,
    register_time_end: dayjs().format('YYYY-MM-DD'),
    ...sessionQueryFilterValues,
  });
  const [studies, setStudies] = useState([]);
  const [studiesTotal, setStudiesTotal] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);

  //判断输入条件中是否满足要求
  const isEmpty = (values: any) => {
    if (
      !values.no_value &&
      !values.chinese_name &&
      !values.check_view2 &&
      !values.diagnosis_result2 &&
      !values.register_dept &&
      !values.register_man
    ) {
      return true;
    } else {
      return false;
    }
  }

  const getDay = (flag, form) => {
    // 获取当前日期
    const currentDate = new Date();
    let statusDay;

    const values = form.getFieldsValue();
    if (flag === 'all' && isEmpty(values)) {
      Modal.warning({
        content: (
          <p>
            查询的时间超过1年，请在查询条件的编号、病人姓名、检查所见、检查结果、送检科室、送检人员中至少输入一项！
          </p>
        ),
      });
      return false;
    }
    const newValues = {
      currentPage: '1',
      pageSize: 10,
      ...values,
    }

    // 获取 3 个月前的日期
    function getPreviousMonthDate(date, monthsBack) {
      const newDate = new Date(date);
      newDate.setMonth(date.getMonth() - monthsBack);

      // 检查日期溢出，如果发生溢出，调整为该月的最后一天
      if (newDate.getDate() !== date.getDate()) {
        newDate.setDate(0); // 设置为上个月的最后一天
      }

      return newDate;
    }
    // 获取三个月前的日期
    if (flag === 'threeMonths') {
      const threeMonthsAgo = getPreviousMonthDate(currentDate, 3);
      statusDay = dayjs(threeMonthsAgo).format('YYYY-MM-DD');
    } else if (flag === 'sixMonths') {
      // 获取 6 个月前的日期
      const sixMonthsAgo = getPreviousMonthDate(currentDate, 6);
      statusDay = dayjs(sixMonthsAgo).format('YYYY-MM-DD');
    } else if (flag === 'oneYear') {
      // 获取 1 年前的日期
      const oneYearAgo = getPreviousMonthDate(currentDate, 12);
      statusDay = dayjs(oneYearAgo).format('YYYY-MM-DD');
    } else if (flag === 'all') {
    }

    setFilterValues({
      ...filterValues,
      currentPage: 1,
      register_time_begin: statusDay,
      register_time_end: dayjs().format('YYYY-MM-DD'),
    });
  };

  const getData = (params?) => {
    const formData = new FormData();
    if (params) {
      for (const i in params) {
        formData.append(i, params[i]);
      }
    }

    setTableLoading(true);

    apiService({
      uri: '/api/reglist/stream-page',
      method: 'POST',
      data: formData,
      type: null,
    })
      .then(res => {
        if (res?.Data) {
          setTableLoading(false);
          let data = res.Data;
          data = data.map((item, index) => {
            item.index = (params.currentPage - 1) * params.pageSize + index + 1;
            item.REGISTER_TIME = dayjs(item.REGISTER_TIME).format('YYYY-MM-DD HH:mm:ss');
            return item;
          });
          const total = Number(res.totalCount);
          const normalizedData = normalizeDataIndex(data, true);
          setStudies(normalizedData);
          setStudiesTotal(total);
        }
      })
      .catch(res => {
        setTableLoading(false);
        console.log('请求检查列表报错', res);
      });
  };

  const normalizeDataIndex = (data, toLowerCase = true) => {
    const normalizedData = data.map(item => {
      const normalizedItem = {};
      Object.keys(item).forEach(key => {
        const normalizedKey = toLowerCase ? key.toLowerCase() : key.toUpperCase();
        normalizedItem[normalizedKey] = item[key];
      });
      return normalizedItem;
    });
    return normalizedData;
  };

  const setFilterValues = val => {
    _setFilterValues(val);
    sessionStorage.setItem('filterValues', JSON.stringify(val));
  };

  const getSecondDay = date => {
    const secondDay = new Date(date);
    secondDay.setDate(secondDay.getDate() + 1);
    return dayjs(secondDay).format('YYYY-MM-DD') + ' 00:00:00';
  };

  // Sync URL query parameters with filters
  useEffect(() => {
    if (!filterValues) {
      return;
    }

    const newData = { ...filterValues };
    Object.keys(newData).forEach(key => {
      if (
        !newData[key] ||
        newData[key] === '' ||
        newData[key].length === 0 ||
        key === 'no_type' ||
        key === 'no_value'
      ) {
        delete newData[key];
      }

      if (key === 'register_time_end' && newData.register_time_end) {
        newData.register_time_end = getSecondDay(newData.register_time_end);
      }

      if (key === 'register_time_begin' && newData.register_time_begin) {
        newData.register_time_begin =
          dayjs(newData.register_time_begin).format('YYYY-MM-DD') + ' 00:00:00';
      }
    });
    getData(newData);
  }, [filterValues]);

  return (
    <div>
      {
      flag === 'mobile' ?
        <MobilePage
          studies={studies}
          studiesTotal={studiesTotal}
          tableLoading={tableLoading}
          onValuesChange={setFilterValues}
          filterValues={{ ...filterValues }}
          filtersMeta={filtersMeta}
          handleTabChange={handleTabChange}
          normalizeDataIndex={normalizeDataIndex}
          getDay={getDay}
          isEmpty={isEmpty}
        />
       :
        <MainPage
          studies={studies}
          studiesTotal={studiesTotal}
          tableLoading={tableLoading}
          onValuesChange={setFilterValues}
          filterValues={{ ...filterValues }}
          filtersMeta={filtersMeta}
          handleTabChange={handleTabChange}
          normalizeDataIndex={normalizeDataIndex}
          getDay={getDay}
          isEmpty={isEmpty}
        />
      }
    </div>
  );
};

StudyListPage.propTypes = {
  handleTabChange: PropTypes.func.isRequired,
};

export default StudyListPage;
